import React from "react";
import Footer from "../components/Footer";
import "./Platform.css";

const Platform = () => {
  return (
    <div className="platform-page">
      <section className="platform-hero">
        <div className="platform-badge"><span className="badge-dot"></span> Platform Overview</div>
        <h1>The AI Platform Built<br /><span className="gradient-text">for Enterprise</span></h1>
        <p>Contextly AI is a complete RAG-as-a-Service platform designed for teams that demand accuracy, security, and speed.</p>
      </section>

      <section className="platform-stats">
        <div className="stat-card"><div className="stat-number">15</div><div className="stat-label">Sources Per Session</div></div>
        <div className="stat-card"><div className="stat-number">PDF, URL, TXT</div><div className="stat-label">Supported Formats</div></div>
        <div className="stat-card"><div className="stat-number">RAG</div><div className="stat-label">Retrieval Engine</div></div>
        <div className="stat-card"><div className="stat-number">Gemini</div><div className="stat-label">Powered by Google AI</div></div>
      </section>

      <section className="platform-sections">
        <div className="platform-section">
          <div className="platform-section-icon"><i className="fa fa-brain"></i></div>
          <h3>Smart Document Understanding</h3>
          <p>Upload PDFs, web pages, or plain text and our AI chunks, embeds, and indexes your content automatically. Ask questions and get citation-backed answers grounded in your own data.</p>
        </div>
        <div className="platform-section">
          <div className="platform-section-icon"><i className="fa fa-search"></i></div>
          <h3>Contextual Retrieval</h3>
          <p>Powered by vector embeddings and semantic search, Contextly retrieves the most relevant passages from your sources to generate accurate, context-aware responses every time.</p>
        </div>
        <div className="platform-section">
          <div className="platform-section-icon"><i className="fa fa-file-alt"></i></div>
          <h3>Multi-Format Support</h3>
          <p>Ingest PDFs, web URLs, and text blocks in a single session. Each source is independently indexed and searchable, giving you a unified knowledge base across different formats.</p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Platform;
